import { registerValidator } from '@philips-emr/tws-core/lib/services/model-service';

const COMPETENCE_VALIDATOR = 'competence-validator';
const PATTERN = /^((0[1-9])|(1[0-2]))\/(\d{4})$/g;

export default registerValidator(COMPETENCE_VALIDATOR, (value: string) => {
  if (!value) {
    return [];
  }

  const valid = Boolean((value).match(PATTERN));

  return [
    {
      message: !valid ? 'provider.invalidy-date-format' : '',
      name: COMPETENCE_VALIDATOR,
      valid,
    },
  ];
});
